"use client";
import {
	IconAlertTriangle,
	IconCircleCheck,
	IconCircleX,
	IconInfoCircle,
	IconLoader2,
} from "@tabler/icons-react";
/**
 * Sonner Toaster — StudyHub soft-tint оформление.
 *
 * Уникальный вид вместо стандартного shadcn / richColors: мягкая цветная
 * подложка по типу, иконка в плитке, аккуратный крестик справа.
 * Визуальный слой задаётся в `packages/ui/src/styles/toast.css`
 * (импортируется из apps/{web,admin}/src/styles.css).
 *
 * - 5 Tabler-иконок (success / error / warning / info / loading)
 * - top-center с safe-area-aware offset (web); admin переопределяет position
 * - closeButton включён по умолчанию
 */
import { Toaster as SonnerToaster, type ToasterProps, toast } from "sonner";

export function Toaster(props: ToasterProps) {
	return (
		<SonnerToaster
			theme="system"
			position="top-center"
			closeButton
			className="toaster"
			icons={{
				success: <IconCircleCheck />,
				error: <IconCircleX />,
				warning: <IconAlertTriangle />,
				info: <IconInfoCircle />,
				loading: <IconLoader2 className="animate-spin" />,
			}}
			// Офсет ниже топбара ИЛИ гарантированно ниже статус-бара. На overlay-
			// роутах --topbar-height=0, а Android Capacitor WebView нередко отдаёт
			// env(safe-area-inset-top)=0 → тост залезал под системные иконки (фидбек).
			// Пол `env-top + 3.5rem` (≈56px) очищает статус-бар даже при обоих нулях;
			// при наличии топбара max() выбирает «ниже топбара».
			offset={{
				top: "max(calc(var(--topbar-height, 0px) + 0.5rem), calc(env(safe-area-inset-top, 0px) + 3.5rem))",
			}}
			// ВАЖНО: sonner ≤600px вьюпорта берёт ОТДЕЛЬНЫЙ `mobileOffset` (→ CSS
			// `--mobile-offset`, дефолт 16px), а `offset` выше игнорирует. Без этого
			// в мобильном приложении тост садился на 16px от верха — прямо под
			// статус-бар (фидбек 2026-06-09). На mobile топбар-переменная не видна
			// порталу <body>, поэтому floor только по safe-area + 4rem (≈64px) —
			// уверенно ниже системных иконок даже при env(safe-area-inset-top)=0.
			mobileOffset={{
				top: "calc(env(safe-area-inset-top, 0px) + 4rem)",
			}}
			{...props}
		/>
	);
}
Toaster.displayName = "Toaster";

export { toast };
